import { InfoCircleTwoTone } from '@ant-design/icons';
import React from 'react';
import { Tag } from 'antd';

const { CheckableTag } = Tag;

type FilterPropsType = {
    filters: string[];
    callback: (filters: string[]) => any;
    style?: React.CSSProperties;
};

class PlantNetworkFilter extends React.Component<
    FilterPropsType,
    { visualizationBox: any; selectedTags: string[]; alreadyClicked: boolean }
> {
    constructor(props: any) {
        super(props);
        this.state = {
            visualizationBox: undefined, // {x: number; y: number; height: number; width: number }
            //filters: {}
            selectedTags: [],
            alreadyClicked: false,
        };
    }

    componentDidMount(): void {
        //empty method
    }

    componentDidUpdate(): void {
        if (this.state.selectedTags.join() !== this.props.filters.join() && !this.state.alreadyClicked)
            this.setState({ selectedTags: this.props.filters });
    }

    handleChange(tag: any, checked: any) {
        this.setState({ alreadyClicked: true });
        const { selectedTags } = this.state;
        const nextSelectedTags = checked ? [...selectedTags, tag] : selectedTags.filter((t) => t !== tag);
        console.log('You are interested in: ', nextSelectedTags);
        this.props.callback(nextSelectedTags);
        this.setState({ selectedTags: nextSelectedTags });
    }

    render(): JSX.Element {
        const { selectedTags } = this.state;

        const filters = this.props.filters;

        return (
            <div style={this.props.style}>
                <div style={{ marginBottom: '5px' }}>
                    <InfoCircleTwoTone style={{ marginRight: '5px' }} />
                    Click the blue buttons to hide/show the graph node
                </div>

                <span style={{ marginRight: 8 }}>Categories:</span>
                {this.props.filters.map((tag) => (
                    <CheckableTag
                        key={tag}
                        checked={selectedTags.indexOf(tag) > -1}
                        onChange={(checked) => this.handleChange(tag, checked)}
                        //style={this.getTagStyle(tag,selectedTags.indexOf(tag) > -1)}
                    >
                        {tag}
                    </CheckableTag>
                ))}
            </div>
        );
    }
}

export default PlantNetworkFilter;
